import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
import LicenceList from './licences/LicenceList';
import LicenceForm from './licences/LicenceForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addLicencesAction } from '../../actions/licencesActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { LICENCIAS_CREAR, PARAMETROS_CREAR } from '../../data/objects';
//Función principal
const Licences = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addLicencesAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, LICENCIAS_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Licencias' 
                subtitle='Utilidades' 
                nodes={nodes}
                actions={actions}
                component={LicenceList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <LicenceForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Licences;